import { Paper } from "@mui/material";
import ActioItemsTable from "./ActioItemsTable";


const ActionItemsTableCard = () => {
  return (
    <>
      <Paper sx={{ padding: "8px 16px", mb: 2 }}>
        <ActioItemsTable />
      </Paper>
    </>
  );
};

export default ActionItemsTableCard;
